import React, { useEffect, useState } from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import MainLayout from "../../../../common/layout/MainLayout";
import { useLocation, useNavigate } from "react-router-dom";
import { path } from "../../../../constants/apiPath";
import instance from "../../../../common/api/interceptor";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import MilestoneMapComponent from "./MilestoneMapComponent";
import Loading from "../../../loading/Loading";
import Tab from "@mui/material/Tab";
import SwipeableViews from "react-swipeable-views";
import { TabList, TabPanel, TabContext } from "@mui/lab";

function MilestoneComponent() {
  const [value, setValue] = useState(0);
  const navigate = useNavigate();
  const [milestoneData, setMilestoneData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [mapData, setMapData] = useState([]);
  const [containerData, setContainerData] = useState([]);
  const [currentPin, setCurrentPin] = useState({})

  const location = useLocation();

  console.log({ containerData });

  useEffect(() => {
    getContainerLocation(location?.state?.masterBill ?? "");
    getRoutes(location?.state?.masterBill ?? "")
  }, []);


  console.log({ mapData })
  const getRoutes = (data) => {
    console.log({ data });
    const obj = {
      containerNumber: data,
      sealine: location?.state?.carrier,
      api_key: "",
      force_update: false
    };

    const url = `${path.GET_ROUTES_BASED_ON_MBL}?mblNumber=${obj.containerNumber}&sealine=${obj.sealine}&api_key=${obj.api_key}&type=BL`;
    instance
      .post(url)
      .then((res) => {
        if (res.data?.route.length) {
          setMapData(res.data.route ?? [])
          setCurrentPin({ lat: res.data.pin[0], lng: res.data.pin[1] })
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
        if (err.response) {
          NotificationManager.error(err.response.data.Message, "", 3000);
        } else if (err.request) {
        } else if (err.message) {
        } else {
          NotificationManager.error("Something went wrong!", "", 3000);
        }
      });
  }

  const getContainerLocation = (data) => {
    console.log({ data });
    const obj = {
      containerNumber: data,
      sealine: location?.state?.carrier,
      api_key: "",
      force_update: false
    };

    const url = `${path.TRACKING_USING_MBL}?mblNumber=${obj.containerNumber}&sealine=${obj.sealine}&api_key=${obj.api_key}&type=BL`;
    instance
      .post(url)
      .then((res) => {
        if (Object.keys(res.data).length > 0) {
          setMilestoneData(res.data.containers ?? []);
          // setMapData(res.data.locations ?? []);
          setContainerData(res.data.containers ?? []);
        }
        if (res.status === "error") {
          NotificationManager.error(res.message, "", 3000);

        }
        // setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        // setLoading(false);
        if (err.response) {
          NotificationManager.error(err.response.data.Message, "", 3000);
        } else if (err.request) {
        } else if (err.message) {
        } else {
          NotificationManager.error("Something went wrong!", "", 3000);
        }
      });
  };

  return (
    <div className="_orderListFullDetailsMap">
      <MilestoneMapComponent currentPin={currentPin} mapData={mapData} loading={loading} />
      {/* <div className="_orderListFullDetailsDropdownParent">
          <div>dropdown position</div>
        </div> */}
      <div className="_orderListFullDetailsMilestone">
        <h5>
          <span onClick={() => navigate(-1)}>
            <ArrowBackIosIcon />
          </span>
          Milestone({location?.state?.masterBill})
        </h5>
        <div className="_orderFullDetailsLineTabDiv">
          {loading ? (
            <div style={{ height: "100%" }}>
              <Loading />
            </div>
          ) : <TabContext value={value}>

            <TabList
              variant="scrollable"
              scrollButtons="auto"
              onChange={(event, newValue) => {
                setValue(newValue);
              }}
            >
              {containerData.map((value, index) => {
                return <Tab label={value.number} />;
              })}
            </TabList>
            <SwipeableViews
              index={value}
              onChangeIndex={(index) => setValue(index)}
            >
              {containerData.map((ele, index) => {
                return (
                  <TabPanel
                    value={value}
                    index={value}
                    key={index}
                    className="_orderFullDetailsLineDataTabDiv _orderListFullDetailsComponentTableDiv "
                  >
                    <div className="_orderListMilestone">
                      <div className="_orderTimelineDivParent">
                        {milestoneData.length != 0 ? (
                          ele.events.map(
                            (item, index, arr) => {
                              const length = arr.length - 1;
                              return (
                                <div className="_orderTimelineDiv">
                                  <div className="_orderTimelineDotLine">
                                    <div className="_orderTimelineDot "></div>
                                    {length != index ? (
                                      <>
                                        <div className="_orderTimelineLine"></div>
                                      </>
                                    ) : null}
                                  </div>
                                  <div className="_orderTimelineInputs">
                                    <h6>{item.description}</h6>
                                    <table>
                                      <tbody>
                                        <tr>
                                          <td>Est. Date</td>
                                          <td>:</td>
                                          <td>
                                            {!item.actual
                                              ? moment(item.date).format(
                                                "MM-DD-YYYY"
                                              )
                                              : ""}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>Act. Date</td>
                                          <td>:</td>
                                          <td>
                                            {item.actual
                                              ? moment(item.date).format(
                                                "MM-DD-YYYY"
                                              )
                                              : ""}
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              );
                            }
                          )
                        ) : (
                          <div
                            style={{
                              alignItems: "center",
                              justifyContent: "center",
                              display: "flex"
                            }}
                          >
                            Milestone not found
                          </div>
                        )}
                      </div>
                    </div>
                  </TabPanel>
                );
              })}
            </SwipeableViews>
          </TabContext>}
        </div>
      </div>
    </div>
  );
}

export default MilestoneComponent;